<template>
	<div class="flex flex-col gap-[16px]">
		<span class="h-[600px] skeleton w-full"></span>
		<span class="h-[492px] skeleton w-full"></span>
	</div>
</template>

<style scoped lang="scss">
@keyframes pulse-bg {
	0% {
		background-color: $neutral-200;
	}
	50% {
		background-color: $neutral-300;
		opacity: 0.5;
	}
	100% {
		background-color: $neutral-200;
	}
}

.skeleton {
	content: "";
	border-radius: 4px;
	animation: pulse-bg 1s infinite;
}
</style>
